import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import { renderSubmissionCountCell } from '../';
import { Widget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';
import CountWithTextCard from '../../../../analytics/components/countWithTextCard';
import { useComposableDashboardsFiltersContext } from '../../../../analyticsPage/hooks/useComposableDashboardsFiltersContext';
import usePostgreWidgetData from '../../../hooks/usePostgreWidgetData';
import { defaultWidgetData } from '../../helper';
import { IPostgreSubmissionDTO, IPostgreSubmissionWidgetProp } from '../types';

const SubmissionsMetricChartPostgre = ({
  query,
  title,
  widgetName,
}: IPostgreSubmissionWidgetProp) => {
  const { widgetData } = usePostgreWidgetData<IPostgreSubmissionDTO>(query, defaultWidgetData);
  const { restructuredFilters } = useComposableDashboardsFiltersContext();

  let metricData;
  switch (widgetName) {
    case Widget.METRIC_JOINING_DATE:
      metricData = renderSubmissionCountCell(
        {
          value: widgetData.data?.length ?? 0,
        },
        [],
        restructuredFilters,
        query
      );
      break;
    case Widget.METRIC_SUBMISSION_ASSIGN_TTS_MEDIAN:
      metricData = (widgetData as any).medianTimeToProcess;
      break;
    case Widget.METRIC_SUBMISSION_ASSIGN_TTS_MAX:
      metricData = (widgetData as any).maxTimeToProcess;
      break;
    default:
      metricData = 0;
  }

  return (
    <Grid container p={2} rowSpacing={2} justifyContent="space-around">
      <Grid item xs={12}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      {[
        Widget.METRIC_JOINING_DATE,
        Widget.METRIC_SUBMISSION_ASSIGN_TTS_MEDIAN,
        Widget.METRIC_SUBMISSION_ASSIGN_TTS_MAX,
      ].includes(widgetName) ? (
        <Grid item xs="auto">
          <CountWithTextCard variant="h3" count={metricData} fullHeight text="" />
        </Grid>
      ) : (
        Object.keys(widgetData).map(
          (countType) =>
            typeof widgetData[countType] == 'number' && (
              <Grid key={countType} item xs="auto">
                <CountWithTextCard
                  variant="h3"
                  count={
                    renderSubmissionCountCell(
                      {
                        value: widgetData[countType],
                      },
                      [],
                      restructuredFilters,
                      query
                    ) as any
                  }
                  fullHeight
                  text={countType == 'count' ? '' : countType}
                />
              </Grid>
            )
        )
      )}
    </Grid>
  );
};

export default SubmissionsMetricChartPostgre;
